import { indexedDbPersister } from './indexedDbPersister';

/**
 * What `PersistQueryClientProvider` writes to IndexedDB so the guest app works offline.
 *
 * Only queries are cached. A mutation that is paused while offline would otherwise be persisted
 * with its variables, which for guest self check-in include the email or phone the guest typed
 * (#277). No mutation defaults are registered, so a restored mutation could never resume anyway.
 * `queryPersistOptions.test.js` pins this rule.
 */
export const queryPersistOptions = {
  persister: indexedDbPersister,
  maxAge: Infinity,
  buster: process.env.REACT_APP_VERSION || 'dev',
  dehydrateOptions: { shouldDehydrateMutation: () => false },
};
